const BrowserIcon = ({ height }) => {
  return (
    <svg
      viewBox="0 0 512 512"
      xmlSpace="preserve"
      height={height}
      fill="#000000"
    >
      <g id="SVGRepo_iconCarrier">
        <rect y="74.56" fill="#CCCCCC" width="512" height="368.08" />
        <rect x="16" y="90.608" fill="#F2F2F2" width="480" height="336" />
        <path d="M512,74.56V49.12c0-15.816-12.936-28.752-28.752-28.752h-368.24H28.752C12.936,20.368,0,33.304,0,49.12v25.432h512V74.56z" />
        <g opacity={0.25}>
          <path
            fill="#FFFFFF"
            d="M147.032,20.368h-32.024H28.752C12.936,20.368,0,33.304,0,49.12v25.432h115.888L147.032,20.368z"
          />
        </g>
        <circle fill="#D80E47" cx="40.536" cy="47.464" r="8.184" />
        <circle fill="#05C3D6" cx="65.096" cy="47.464" r="8.184" />
        <g>
          <circle fill="#FFFFFF" cx="89.648" cy="47.464" r="8.184" />
          <path
            fill="#FFFFFF"
            d="M428.256,61.84H170.88c-7.904,0-14.376-6.472-14.376-14.376l0,0c0-7.904,6.472-14.376,14.376-14.376 h257.376c7.904,0,14.376,6.472,14.376,14.376l0,0C442.632,55.368,436.16,61.84,428.256,61.84z"
          />
        </g>
        <path d="M180.576,40.904l1.968,7.56c0.432,1.672,0.832,3.2,1.112,4.752h0.096c0.336-1.512,0.832-3.112,1.32-4.72l2.432-7.592h2.28 l2.304,7.456c0.552,1.784,0.984,3.344,1.32,4.856h0.096c0.24-1.512,0.648-3.08,1.144-4.832l2.12-7.488h2.68l-4.8,14.888h-2.464 l-2.288-7.096c-0.52-1.656-0.952-3.144-1.32-4.888h-0.064c-0.368,1.784-0.832,3.328-1.352,4.92l-2.4,7.08h-2.464L177.8,40.912h2.776 V40.904z" />
        <path d="M203.544,40.904l1.968,7.56c0.432,1.672,0.832,3.2,1.112,4.752h0.096c0.336-1.512,0.832-3.112,1.32-4.72l2.432-7.592h2.28 l2.304,7.456c0.552,1.784,0.984,3.344,1.32,4.856h0.096c0.24-1.512,0.648-3.08,1.144-4.832l2.12-7.488h2.68l-4.8,14.888h-2.464 l-2.288-7.096c-0.52-1.656-0.952-3.144-1.32-4.888h-0.064c-0.368,1.784-0.832,3.328-1.352,4.92l-2.4,7.08h-2.464l-4.496-14.888 h2.776V40.904z" />
        <path d="M226.512,40.904l1.968,7.56c0.432,1.672,0.832,3.2,1.112,4.752h0.096c0.336-1.512,0.832-3.112,1.32-4.72l2.432-7.592h2.28 l2.304,7.456c0.552,1.784,0.984,3.344,1.32,4.856h0.096c0.24-1.512,0.648-3.08,1.144-4.832l2.12-7.488h2.68l-4.8,14.888h-2.464 l-2.288-7.096c-0.52-1.656-0.952-3.144-1.32-4.888h-0.064c-0.368,1.784-0.832,3.328-1.352,4.92l-2.4,7.08h-2.456l-4.496-14.888 h2.768V40.904z" />
        <path d="M246.192,54.2c0-1.144,0.768-1.936,1.84-1.936s1.816,0.8,1.816,1.936c0,1.112-0.704,1.936-1.84,1.936 C246.928,56.136,246.192,55.312,246.192,54.2z" />
        <g>
          <rect x="461.328" y="45.832" fill="#FFFFFF" width="23" height="4" />
          <polygon
            fill="#FFFFFF"
            points="474.592,59.76 471.752,56.936 480.856,47.832 471.752,38.728 474.592,35.904 486.512,47.832 "
          />
        </g>
        <polygon
          fill="#C9C9C9"
          points="429.824,42.816 422.168,52.72 414.512,42.816 "
        />
        <path
          fill="#FFFFFF"
          d="M492,94.608v328H20v-328L492,94.608 M496,90.608H16v336h480V90.608L496,90.608z"
        />
        fill="#05C3D6"
        <circle fill="#05C3D6" cx="256" cy="317.488" r="174.144" />
        <rect
          x="157.184"
          y="277.328"
          fill="#FFFFFF"
          width="56.56"
          height="14.128"
        />
        <rect x="171.312" y="305.616" width="28.264" height="14.128" />
        <rect
          x="242"
          y="192.568"
          fill="#FFFFFF"
          width="56.56"
          height="14.128"
        />
        <rect x="157.184" y="220.848" width="84.784" height="14.128" />
        <rect
          x="284.36"
          y="220.848"
          fill="#FFFFFF"
          width="70.656"
          height="14.128"
        />
        <rect x="312.64" y="333.888" width="70.656" height="14.128" />
        <rect
          x="326.752"
          y="362.136"
          fill="#FFFFFF"
          width="56.56"
          height="14.128"
        />
        <rect x="209.92" y="249.088" width="116.816" height="14.128" />
        <rect x="256.08" y="333.888" width="28.264" height="14.128" />
        <rect x="270.232" y="362.136" width="28.264" height="14.128" />
        <rect x="284.36" y="390.368" width="28.264" height="14.128" />
        <rect x="256.08" y="277.328" width="84.784" height="14.128" />
        <rect
          x="227.84"
          y="305.616"
          fill="#FFFFFF"
          width="84.784"
          height="14.128"
        />
        <rect x="157.184" y="390.368" width="84.784" height="14.128" />
        <rect x="143.056" y="333.888" width="84.784" height="14.128" />
        <rect
          x="128.88"
          y="362.136"
          fill="#FFFFFF"
          width="84.784"
          height="14.128"
        />
      </g>
    </svg>
  );
};

export default BrowserIcon;
